import { WatchOrganizationService } from './../../../services/watch-organization.service';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Observable } from 'rxjs';
import { IPermission } from '../../../interfaces/graph-types';

@Component({
  selector: 'organization-team',
  template: require('./organization-team.component.pug'),
  styles: [require('./organization-team.component.css').toString()],
})
export class OrganizationTeamComponent {
  permissions$: Observable<IPermission[]>;
  bsModalRef: BsModalRef;
  orgId: string = null;

  // -------------------------------------------------------------------
  constructor(private watch: WatchOrganizationService) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.orgId = this.watch.organizationId().getValue();
  }
}
